import { SharingStatusFilters } from '@shared/constants/filters';
import { initPatientsRootState } from '@shared/redux/reducers/initState/initPatientsRootState';
import { FiltersState } from '@shared/redux/state/patients';
import { PatientFilterValue } from '@shared/util/filters/patient-filters-helper';

export const PATIENTS_ADMIN_LIST_SET_FILTER = 'PATIENTS_ADMIN_LIST_SET_FILTER';
export const PATIENTS_ADMIN_LIST_REMOVE_FILTER = 'PATIENTS_ADMIN_LIST_REMOVE_FILTER';
export const PATIENTS_ADMIN_LIST_CLEAR_FILTERS = 'PATIENTS_ADMIN_LIST_CLEAR_FILTERS';
export const PATIENTS_ADMIN_LIST_CHANGE_SHARING_STATUS = 'PATIENTS_ADMIN_LIST_CHANGE_SHARING_STATUS';
export const PATIENTS_ADMIN_LIST_CHANGE_SHARED_TO_ME = 'PATIENTS_ADMIN_LIST_CHANGE_SHARED_TO_ME';
export const PATIENTS_ADMIN_LIST_SHARE_TO_TENANT = 'PATIENTS_ADMIN_LIST_SHARE_TO_TENANT';
export const PATIENTS_ADMIN_LIST_CHANGE_USERS_IN_CHARGE = 'PATIENTS_ADMIN_LIST_CHANGE_USERS_IN_CHARGE';
export const PATIENTS_ADMIN_LIST_SELECT_ALL = 'PATIENTS_ADMIN_LIST_SELECT_ALL';
export const PATIENTS_ADMIN_LIST_SELECT_NONE = 'PATIENTS_ADMIN_LIST_SELECT_NONE';
export const PATIENTS_ADMIN_LIST_SET_FILTERS_STATE = 'PATIENTS_ADMIN_LIST_SET_FILTERS_STATE';

export const setFilter = (filterKey: keyof FiltersState, filterValue: PatientFilterValue) =>
  ({
    type: PATIENTS_ADMIN_LIST_SET_FILTER,
    payload: {
      filterKey,
      filterValue,
    },
  } as const);

export const changeSharingStatus = (filterValue: SharingStatusFilters) =>
  ({
    type: PATIENTS_ADMIN_LIST_CHANGE_SHARING_STATUS,
    payload: {
      filterValue,
    },
  } as const);

export const changeSharedToMe = (filterValue: string) =>
  ({
    type: PATIENTS_ADMIN_LIST_CHANGE_SHARED_TO_ME,
    payload: {
      filterValue,
    },
  } as const);

export const shareToTenant = (filterValue: string) =>
  ({
    type: PATIENTS_ADMIN_LIST_SHARE_TO_TENANT,
    payload: {
      filterValue,
    },
  } as const);

export const changeUsersInCharge = (filterValue: string) =>
  ({
    type: PATIENTS_ADMIN_LIST_CHANGE_USERS_IN_CHARGE,
    payload: {
      filterValue,
    },
  } as const);

export const clearFilters = () =>
  ({
    type: PATIENTS_ADMIN_LIST_CLEAR_FILTERS,
    payload: initPatientsRootState.adminList.filters,
  } as const);

export const removeFilter = (filterKey: keyof FiltersState) =>
  ({
    type: PATIENTS_ADMIN_LIST_REMOVE_FILTER,
    payload: { filterKey },
  } as const);

export const selectAll = (filterKey: keyof FiltersState, options: PatientFilterValue[]) =>
  ({
    type: PATIENTS_ADMIN_LIST_SELECT_ALL,
    payload: {
      filterKey,
      filterValue: options.filter((opt) => opt != null),
    },
  } as const);

export const selectNone = (filterKey: keyof FiltersState) =>
  ({
    type: PATIENTS_ADMIN_LIST_SELECT_NONE,
    payload: {
      filterKey,
      filterValue: [],
    },
  } as const);

export const setFiltersState = (filtersState: FiltersState) =>
  ({
    type: PATIENTS_ADMIN_LIST_SET_FILTERS_STATE,
    payload: filtersState,
  } as const);

export type SetFilter = ReturnType<typeof setFilter>;
export type ChangeSharingStatus = ReturnType<typeof changeSharingStatus>;
export type ChangeSharedToMe = ReturnType<typeof changeSharedToMe>;
export type ShareToTenant = ReturnType<typeof shareToTenant>;
export type ChangeUsersInCharge = ReturnType<typeof changeUsersInCharge>;
export type ClearFilters = ReturnType<typeof clearFilters>;
export type RemoveFilter = ReturnType<typeof removeFilter>;
export type SelectAll = ReturnType<typeof selectAll>;
export type SelectNone = ReturnType<typeof selectNone>;
export type SetFiltersState = ReturnType<typeof setFiltersState>;

export type PatientsAdminListFiltersAction =
  | SetFilter
  | ChangeSharingStatus
  | ChangeSharedToMe
  | ShareToTenant
  | ChangeUsersInCharge
  | ClearFilters
  | RemoveFilter
  | SelectAll
  | SelectNone
  | SetFiltersState;
